import { useWalletModal } from "@solana/wallet-adapter-ant-design";
import { useWallet } from "@solana/wallet-adapter-react";
import { Row } from "antd";
import { useState } from "react";
import { withTranslation } from "react-i18next";
import { useStack } from "../../hooks/useStaking";
import useWindowSize from "../../hooks/useWindowSize";
import {
  CustomNavLinkSmall,
  HeaderSection,
  NavbarLinkRoot,
  Span,
  WalletInfoText,
  DisconnectButton,
  ProgressBar,
  Progress,
  ProgressTitle,
  StakedAnimalsWrapper,
  ConnectButton,
} from "./styles";

const Header = ({ t }: any) => {
  const { jungle } = useStack();
  const numAnimalsStaked = jungle?.animalsStaked.toNumber() || 0;
  const percentageStaked = parseFloat(
    ((numAnimalsStaked / 10000) * 100).toFixed(2)
  );

  const { isMobile, isTabPort } = useWindowSize();

  const MenuItem = () => {
    const { setVisible: setOpenWalletModal } = useWalletModal();
    const { disconnect, connected, publicKey } = useWallet();

    return (
      <NavbarLinkRoot>
        <CustomNavLinkSmall
          onClick={() =>
            window.open(
              "https://www.magiceden.io/marketplace/baby_ape_social_club"
            )
          }
        >
          <Span>{"Buy"}</Span>
        </CustomNavLinkSmall>

        {connected ? (
          <>
            <DisconnectButton onClick={() => disconnect()}>
              Disconnect
            </DisconnectButton>
            <WalletInfoText>
              <svg
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 25 25"
              >
                <title>Wallet</title>
                <path
                  id="Wallet"
                  d="M20,15a1,1,0,1,1-1-1A1,1,0,0,1,20,15Zm5-1.75v3.5A1.23,1.23,0,0,1,24,18v3.8A1.25,1.25,0,0,1,22.75,23H2.5A2.5,2.5,0,0,1,0,20.5V5.5A2.5,2.5,0,0,1,2.5,3H20.75A1.25,1.25,0,0,1,22,4.25V7h.75A1.25,1.25,0,0,1,24,8.25v3.8A1.23,1.23,0,0,1,25,13.25ZM1,5.5a1.46,1.46,0,0,0,.46,1.08A1.49,1.49,0,0,0,2.5,7H21V6H3V5H21V4.25A.25.25,0,0,0,20.75,4H2.5A1.5,1.5,0,0,0,1,5.5ZM23,18H19a3,3,0,1,1,0-6h4V8.25A.25.25,0,0,0,22.75,8H2.5A2.47,2.47,0,0,1,1,7.48v13A1.5,1.5,0,0,0,2.5,22H22.75a.25.25,0,0,0,.25-.25Zm1-4.75a.25.25,0,0,0-.25-.25H19a2,2,0,0,0-2,2.34A2.08,2.08,0,0,0,19.11,17h4.64a.25.25,0,0,0,.25-.25Z"
                />
              </svg>{" "}
              {publicKey?.toString().substring(0, 4)}...
              {publicKey
                ?.toString()
                .substring(
                  publicKey?.toString().length - 2,
                  publicKey?.toString().length
                )}
            </WalletInfoText>
          </>
        ) : (
          <ConnectButton onClick={() => setOpenWalletModal(true)}>
            Connect
          </ConnectButton>
        )}
      </NavbarLinkRoot>
    );
  };

  return (
    <HeaderSection>
      <Row style={{ marginTop: isMobile ? "" : "30px" }}>
        <StakedAnimalsWrapper>
          <ProgressTitle>
            Apes & Tigers Staked: {numAnimalsStaked} ({percentageStaked}%)
          </ProgressTitle>
          <ProgressBar>
            <Progress style={{ width: `${Math.ceil(percentageStaked)}%` }} />
          </ProgressBar>
        </StakedAnimalsWrapper>
      </Row>
      <Row style={{ marginTop: isTabPort ? "10px" : "50px" }} justify="center">
        <MenuItem />
      </Row>
    </HeaderSection>
  );
};

export default Header;
